//
// ResultController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";
import "../../models/results/Result";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataSet";
import "@sas-dvr/ltjs-commons/models/data/DataValue";
import "@sas-dvr/ltjs-commons/models/data/hierarchy/HierarchyDataSet";
import "./sorting/SortController";
import "../../models/results/ResultVariable";

var ResultController = createModule("BIRD::ResultController", ["BIRD::BIRDModelController"], EventDispatcher, [
    {
        NO_RESPONSE_FROM_SERVER: 50023,
        REPORT_OBJECT_INCOMPLETE: 50029,
        RESULT_DATA_WARNING: 50022,
        FILTER_PRODUCED_EMPTY_DATA: 50026,
        DATA_BEGAN_PROCESSING: 50043,
        UNRECOGNIZED_RESPONSE: 50024,
        MAX_ROWS_EXCEEDED_DATA_TRUNCATED: 50027,
        INCOMPLETE_DATA: 50025,
        MAX_ROWS_EXCEEDED_NO_DATA: 50028,
    },
    ,
    ,
    ,
    {
        getDataSet: [1],
        getHierarchyDataSet: [1],
        getSyntheticItemSetVariables: [[1],7],
        getModel: [1],
        getVariableLabelForPresentation: [7,7,7],
        isProcessingData: [2],
        getSortController: [1],
        getResultLabelForPresentation: [7,7],
        getDataWarnings: [[1]],
        getDataValueForStringValue: [1,7],
        isDataEmbedded: [2],
    },
    ,
    ,
]);
export default ResultController;
